export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./coupon.vue?vue&type=template&id=432aaebc"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/branches/branch/bonuses/coupon.vue?vue&type=template&id=432aaebc
// module id = XQB8
// module chunks = 0